import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-mandatory-extras-warning',
  templateUrl: './mandatory-extras-warning.component.html',
  styleUrls: ['./mandatory-extras-warning.component.scss']
})
export class MandatoryExtrasWarningComponent implements OnInit {
  @Input('extras') extras: any[];
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
    console.log(this.extras);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/atoms/mandatory-extras-warning/mandatory-extras-warning.component.ts